import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { OC_API } from 'OpsCenter/app.constants';

@Component({
  selector: 'app-daterangepicker',
  template: require('./daterangepicker.component.html'),
  styles: [require('./daterangepicker.component.scss')],
})
export class DaterangepickerComponent {
  @ViewChild('datepicker', { static: true }) datepicker;

  @Input() invalid: boolean;
  @Input() disableTyping: boolean;

  @Input()
  public set minDate(date: Date) {
    if (!date) {
      return;
    }

    const formattedDate = moment(date).format(OC_API.JUST_DATE_WITH_DOTS_FORMAT);
    const { year, month, day } = this.formatter.parse(formattedDate);
    this.min = new NgbDate(year, month, day);
  }

  @Input()
  public set startDate(date: Date) {
    if (!date) {
      return;
    }

    const formattedDate = moment(date).format(OC_API.JUST_DATE_WITH_DOTS_FORMAT);
    const { year, month, day } = this.formatter.parse(formattedDate);
    this.fromDate = new NgbDate(year, month, day);
  }

  @Input()
  public set endDate(date: Date) {
    if (!date) {
      return;
    }

    const formattedDate = moment(date).format(OC_API.JUST_DATE_WITH_DOTS_FORMAT);
    const { year, month, day } = this.formatter.parse(formattedDate);
    this.toDate = new NgbDate(year, month, day);
  }

  @Output() validated = new EventEmitter<boolean>();
  @Output() startDateUpdated = new EventEmitter<Date>();
  @Output() endDateUpdated = new EventEmitter<Date>();

  public fromDate: NgbDate;
  public toDate: NgbDate;
  public min: NgbDate;
  public hoveredDate: NgbDate;
  public daterange: string;

  constructor(private calendar: NgbCalendar, private formatter: NgbDateParserFormatter) {
  }

  public onInputChange(): void {
    const [from, to] = this.daterange.split('-');

    if (from && (!this.fromDate || moment(this.fromDate).isValid())) {
      const { year, month, day } = this.formatter.parse(from);
      this.fromDate = new NgbDate(year, month, day);
    } else {
      this.fromDate = null;
    }

    if (to && (!this.toDate || moment(this.toDate).isValid())) {
      const { year, month, day } = this.formatter.parse(to);
      this.toDate = new NgbDate(year, month, day);
    } else {
      this.toDate = null;
    }

    this.emitValue();
  }

  public onDateSelection(date: NgbDate): void {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      this.datepicker.close();
    } else if (this.fromDate && date.equals(this.fromDate)) {
      this.toDate = this.fromDate;
      this.datepicker.close();
    } else {
      this.fromDate = date;
      this.toDate = null;
    }

    this.updateInputValue();
    this.emitValue();
  }

  public isHovered(date: NgbDate): boolean {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  public isInside(date: NgbDate): boolean {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  public isRange(date: NgbDate): boolean {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  private updateInputValue(): void {
    this.daterange = this.formatter.format(this.fromDate) + ' - ' + this.formatter.format(this.toDate);
  }

  private emitValue(): void {
    const start = this.formatter.format(this.fromDate);
    const end = this.formatter.format(this.toDate);

    const startAsMoment = moment(start, OC_API.JUST_DATE_WITH_DOTS_FORMAT);
    const endAsMoment = moment(end, OC_API.JUST_DATE_WITH_DOTS_FORMAT);

    const invalid = !(this.fromDate && this.toDate && startAsMoment.isSameOrBefore(endAsMoment));
    this.validated.emit(invalid);

    if (!invalid) {
      this.startDateUpdated.emit(startAsMoment.toDate());
      this.endDateUpdated.emit(endAsMoment.toDate());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/daterangepicker/daterangepicker.component.ts